import socketIOClient from "socket.io-client";
import Desktop from ".";

import { countTickets, fetchTicketHistory } from "@/modules/commonMachineGame";
import { initUserdata, resetCommonGameProps, processLoadNewValueWin, skipLoadNewValuePcodes, pushGameResultHistory, resetNewSet, resetVirtualDisplays, recountTotal, postLoadNewValue, applyGongBallResult, GongBallSides, getLastBetArray, purgeApplyLastBet, applyClearBet } from "@/modules/commonMobile";
import { setWinModal } from "@/modules/modals";
import { getSocketEndpoint, getDefaultSocketParameters } from "@/modules/sockets";
import { playPlayerVoice, playBankerVoice, playDragonVoice, playTigerVoice } from "@/modules/sounds";
import { loadNewValueLottoResultCleanupDelay } from "@/modules/timeouts";
import { newGetPcode, getBasePcode, isMachineGame, v2games } from "@/modules/gamePcode";
import { defaultDragonTigerResult, defaultShioFightResult } from "@/modules/virtualCards";
import { INiuNiuHistoryType } from "@/types/GameHistoryTypes";
import { IBaccaratSocketData, IDragonTigerSocketData, INiuNiuSocketData, ILottoSocketData } from "@/types/GameScannerTypes";
import { IGenericGameResultType, IUserdataType, IKeyStringDict } from "@/types/GlobalTypes";

/**
 * Starts new period with the new time left.
 * @param data Todo: get the formats
 */
function loadNewValue(this: Desktop, data: any) {
	const lobby = this;
	const pcode = newGetPcode(data);
	const basePcode = getBasePcode(pcode);
	const machineGame = isMachineGame(basePcode);

	// winning highlight
	const { games, timers } = this.state;
	const game = games[pcode];

	// console.log("lNV", `game:`, game, `pcode: ${pcode}`);

	// Prevents error messages or UI crash on missing:
	// - state games
	// - game with pcode
	// - time object with pcode
	if (Object.keys(games).length === 0 ||
		!game ||
		!timers[pcode])
		return;

	// if (pcode === "m13")
	// to debug loadNewValue data
	//	console.log("g[" + pcode + "]  lNV dat", data);

	timers[pcode].time = Number(data.timer);

	resetCommonGameProps(game, data);

	processLoadNewValueWin(this, data);

	//if (isDev() &&
	if (skipLoadNewValuePcodes.indexOf(basePcode) < 0) {
		pushGameResultHistory(game, data);
	}

	// Use this on live until the time to use gameResult
	/*
	if (!isDev()) {
		pushGameResultHistory(game, data);
		
		// Enables roadmap blinking
		game.historyBlink = (v2games.indexOf(basePcode) < 0);
	}
	*/


	//Turns off newSet
	resetNewSet(game);

	//Todo: copy this to mobile and see if it works
	window.setTimeout(() => {
		resetVirtualDisplays(game);
		lobby.setState({ games: games });
	}, 1000);

	if (machineGame) {
		// Clears Running Tickets
		delete game.activeBetGroup;
		game.tickets = []; // loadNewValue
		countTickets(game);

		// Fetches ticket history for the previous period
		fetchTicketHistory(this, pcode, Number(data.periode) - 1);
	}

	//Clears lotto result after the last number scan
	// if (machineGame || basePcode === "m32") {
	if (game.lottoResult) {
		window.setTimeout(() => {
			delete game.lottoResult;
			game.win = data.win;
			this.setState({ games: games });
		}, loadNewValueLottoResultCleanupDelay);
	}


	// Generic controller check
	this.checkController(game); // loadNewValue

	// Auto Rebet in loadNewValue
	if (this.state.autoRebet && game.active) {
		if (machineGame)
			// Give time to fetch tickets
			window.setTimeout(() => {
				this.clickRebet({ pcode: pcode }); // loadNewValue
				this.checkController(game); // loadNewValue

				recountTotal(game);

				this.setState({ games: games }); // loadNewValue
			}, 2000);
		else {
			this.clickRebet({ pcode: pcode }); // loadNewValue
			this.checkController(game); // loadNewValue

			recountTotal(game);

			this.setState({ games: games }); // loadNewValue
		}
	}

	// Remove Win for every game except V2 Games
	this.timeoutWin = window.setTimeout(() => {
		this.removeWin(pcode);
	}, machineGame || basePcode === "m31" || basePcode === "m32" ? 7000 : 4000);

	if (game.active)
		postLoadNewValue(this, game, data);

	this.setState({
		games: games,
		timers: timers,
	}); // loadNewValue
}

function applyGameResult(this: Desktop, gameResultData: IGenericGameResultType) {
	const { games } = this.state;
	const { pcode } = gameResultData;

	const activeGame = games[pcode];
	const basePcode = getBasePcode(pcode);

	if (!activeGame)
		return;

	pushGameResultHistory(activeGame, gameResultData);
	activeGame.win = gameResultData.win;

	// Enables roadmap blinking
	activeGame.historyBlink = (v2games.indexOf(basePcode) < 0);

	this.setState({ games: games });

	//Similar to loadNewValue
	// Remove Win for every game except V2 Games
	const machineGame = isMachineGame(basePcode);

	this.timeoutWin = window.setTimeout(() => {
		this.removeWin(gameResultData.pcode);
	}, machineGame ? 7000 : 4000);
}

/**
 * Initialise Socket.IO.
 * Used in: fetchUserData()
 * @param userdata The userdata reference, used in getDefaultSocketParameters()
 */
function initSocketIO(this: Desktop, userdata: IUserdataType) {
	// Made to reduce build time as the server count increases
	const socketEndpoint = getSocketEndpoint(userdata);
	console.warn("Connecting to socket endpoint ", socketEndpoint);
	console.warn("socket userdata ", userdata);
	if (this.state.logSocketEvents)
		console.warn("Connecting to socket endpoint ", socketEndpoint);

	if (!socketEndpoint)
		console.warn("The Socket.IO endpoint isn't set.");

	// For Socket.IO endpoints
	this.socketio = socketIOClient(socketEndpoint, getDefaultSocketParameters(userdata));

	const lobby = this;
	const socket = this.socketio;
	socket.on("loadNewValue", (data: any) => {
		if (this.state.logSocketEvents)
			console.debug("loadNewValue", data);

		// Todo: add socket event suppression
		lobby.loadNewValue(data);
	});

	socket.on("gameResult", (data: IGenericGameResultType) => {
		if (this.state.logSocketEvents)
			console.debug("gameResult", data);

		console.log("gR dat", data);
		lobby.applyGameResult(data);
	});

	socket.on("closeTimer", (data: any) => {
		if (this.state.logSocketEvents)
			console.debug("closeTimer", data);

		// Todo: add socket event suppression

		const pcode = newGetPcode(data);
		lobby.closeTimer(pcode);
	});

	socket.on("receive_totalwin", (data: any) => {
		const { games, userdata } = lobby.state;
		const name = userdata.user.nickname;
		if(name === data.username)
		{
			const pcode = newGetPcode(data);
			setWinModal(games[pcode], Number(data.winamount));
			
			games[pcode].bet = {};
			lobby.setState({ games: games, userdata: userdata }); // recieve_totalwin
			lobby.fetchUserData(null);
			// Plays YOU WON sfx
			lobby.playYouWonSFX();

			// lobby.toggleModal
			window.setTimeout(() => {
				delete games[pcode].winModal;
			}, 5000, { pcode: pcode }, lobby);
		}
	});

	socket.on("receive_balance", (data: any) => {
		const { userdata } = lobby.state;
		const name = userdata.user.nickname;
		if(name === data.username){
			lobby.fetchUserData(null);
		}
	});

	// GAME RELATED SOCKET LISTENERS

	// Gong Ball socket listeners
	socket.on("show_banker", (data: any) => {
		const { games } = this.state;
		applyGongBallResult(games["m16"], GongBallSides.banker, data);
		lobby.setState({ games: games });
	});

	socket.on("show_player", (data: any) => {
		const { games } = this.state;
		applyGongBallResult(games["m16"], GongBallSides.player, data);
		lobby.setState({ games: games });
	});


	const BCIFS: IKeyStringDict = {
		"baccarat": "m22",
		"idn4stand": "m28",
		"baccaratmachine": "m38",
	};

	// Use pcode for this iteration
	["", "b", "c", "d"].forEach(variant => {
		const variantUpper = variant.toUpperCase();

		// BC, I4S & BM socket listener
		for (const key in BCIFS) {
			const baccaratEventName = `${key}${variantUpper}`;

			// Baccarat with Variants
			socket.on(baccaratEventName, (data: IBaccaratSocketData) => {
				// if (this.state.logBaccaratScanEvent)
				//     console.debug(baccaratEventName, data);

				const variantPcode = `${BCIFS[key]}${variant}`;

				const prevValue = this.prevScanValue[variantPcode];

				if (!prevValue) return;

				if (data.banker === prevValue.banker &&
					data.player === prevValue.player &&
					data.submit === prevValue.submit) {
					// console.debug("banker & player is the same");
					return;
				}

				this.prevScanValue[variantPcode] = data;

				if (this.state.logBaccaratScanEvent)
					console.debug("BC state update call");

				if (!lobby.state.games ||
					!lobby.state.games[variantPcode] ||
					!lobby.state.games[variantPcode].roadmap) // active checks active game
					return;

				// Don't play SFX when the game isn't active
				const gameIsActive = lobby.state.games[variantPcode].active;
				const dat: IBaccaratSocketData = typeof (data) === "object" ? data : JSON.parse(data);

				const { games } = lobby.state;

				// Adds delay on baccarat result
				const isVideoSD = this.state.activeVideoQuality === 'sd';

				// if video hd, delay += 5000
				const delayCard = (isVideoSD ? 4000 : 9000),
					delayPlayer = (isVideoSD ? 4500 : 9500),
					delayBanker = (isVideoSD ? 6000 : 11000);

				lobby.baccaratTimeout = window.setTimeout(() => {
					games[variantPcode].virtualCardScanResult = dat;
					lobby.setState({ games: games });
				}, delayCard);

				// Play voice on retrieving result, then reset lastBankerMatch & lastPlayerMatch on loadNewValue in order to play voices only once
				if (!(variantPcode in lobby.baccaratVoiceSets))
					lobby.baccaratVoiceSets[variantPcode] = {
						lastBankerMatch: 0,
						lastPlayerMatch: 0
					};


				// Read player & banker values
				const voiceSet = lobby.baccaratVoiceSets[variantPcode];

				// Player
				const matchPlayerX = (dat.player.match(/x/g) || []).length;
				if (matchPlayerX <= 1)
					lobby.playPlayerVoiceTimeout = window.setTimeout(() => {
						if (gameIsActive && lobby.baccaratVoiceSets[variantPcode].lastPlayerMatch !== matchPlayerX)
							playPlayerVoice(lobby, dat.playerValue);
						voiceSet.lastPlayerMatch = matchPlayerX;
					}, delayPlayer);

				// Banker
				const matchBankerX = (dat.banker.match(/x/g) || []).length;
				if (matchBankerX <= 1)
					lobby.playBankerVoiceTimeout = window.setTimeout(() => {
						if (gameIsActive && voiceSet.lastBankerMatch !== matchBankerX)
							playBankerVoice(lobby, dat.bankerValue);
						voiceSet.lastBankerMatch = matchBankerX;
					}, delayBanker);

				if (gameIsActive &&
					(matchPlayerX <= 2 || matchBankerX <= 2) &&
					(lobby.lastPlayerMatch !== matchPlayerX || lobby.lastBankerMatch !== matchBankerX))
					window.setTimeout(() => {
						lobby.playCardOpenSFX();
					}, delayCard);

				// Note: turn off pushedBigRoad on testing scan result
				if (dat.submit && !games[variantPcode].pushedBigRoad) {
					games[variantPcode].roadmap.big_road.push(dat);
					games[variantPcode].win = data;

					/* data: {
						pcode: "m22c"
						banker: "Ts-Tc-4s"
						player: "2d-2s-2s"
						bankerValue: 4
						playerValue: 6
						value: 6
						win: "player"
						submit: true
						periode: 24
						gameSet: 6445
					} */

					//Todo: diagnose this later

					// reset pushedBigRoad in loadNewValue
					games[variantPcode].pushedBigRoad = true;

					games[variantPcode].historyBlink = true;

					lobby.setState({ games: games });

					if (gameIsActive)
						window.setTimeout(() =>
							dat.win !== "tie" ?
								lobby.playWinVoice(dat.win) :
								lobby.playTieVoice(dat.playerValue + "")
							, 5000);
				}
			});
		}

		// Dragon Tiger Socket and Variants
		// Clone of Baccarat, but with value evaluator
		const DTEventName = `scanDragonTiger${variantUpper}`;
		socket.on(DTEventName, (data: IDragonTigerSocketData | string) => {
			// if (this.state.logDTScanEvent)
			//     console.debug(DTEventName, data);

			const variantPcode = variant !== undefined ? `m23${variant}` : "";

			const { games } = lobby.state;

			if (!games ||
				!games[variantPcode] ||
				!games[variantPcode].roadmap)
				return;

			const dat: IDragonTigerSocketData = typeof (data) === "object" ? data : JSON.parse(data);

			// Diff pattern
			const prevValue = this.prevScanValue[variantPcode];
			if (dat.dragon === prevValue.dragon &&
				dat.tiger === prevValue.tiger) {
				// console.debug("dragon & tiger is the same");
				return;
			}

			this.prevScanValue["m23"] = data;

			if (this.state.logDTScanEvent)
				console.debug("DT state update call");
			// End diff pattern


			// Don't play SFX when the game isn't active
			const gameIsActive = games[variantPcode].active;

			// Adds delay on baccarat result
			lobby.dragonTigerTimeout = window.setTimeout(() => {
				games[variantPcode].virtualCardScanResult = dat;
				lobby.setState({ games: games });
			}, 4000);

			// Play voice on retrieving result, then reset lastBankerMatch & lastPlayerMatch on loadNewValue in order to play voices only once

			// Player
			const matchPlayerX = (dat.dragon.match(/x/g) || []).length;
			if (matchPlayerX <= 1)
				lobby.playPlayerVoiceTimeout = window.setTimeout(() => {
					if (gameIsActive && lobby.lastPlayerMatch !== matchPlayerX)
						playDragonVoice(lobby, dat.dragonValue);
					lobby.lastPlayerMatch = matchPlayerX;
				}, 4500);

			// Banker
			const matchBankerX = (dat.tiger.match(/x/g) || []).length;
			if (matchBankerX <= 1)
				lobby.playBankerVoiceTimeout = window.setTimeout(() => {
					if (gameIsActive && lobby.lastBankerMatch !== matchBankerX)
						playTigerVoice(lobby, dat.tigerValue);
					lobby.lastBankerMatch = matchBankerX;
				}, 6000);

			if (gameIsActive &&
				(matchPlayerX <= 2 || matchBankerX <= 2) &&
				(lobby.lastPlayerMatch !== matchPlayerX || lobby.lastBankerMatch !== matchBankerX))
				window.setTimeout(() => {
					lobby.playCardOpenSFX();
				}, 4000);


			// Note: turn off pushedBigRoad on testing scan result

			if (dat.submit && !games[variantPcode].pushedBigRoad) {
				games[variantPcode].roadmap.big_road.push(dat);
				games[variantPcode].win = data;

				// reset pushedBigRoad in loadNewValue
				games[variantPcode].pushedBigRoad = true;

				games[variantPcode].historyBlink = true;

				lobby.setState({ games: games });

				if (gameIsActive)
					lobby.playResultTimeout = window.setTimeout(() =>
						dat.win !== "tie" ?
							lobby.playWinVoice(dat.win) :
							lobby.playTieVoice(dat.dragonValue + "")
						, 5000);
			}
		});

		const socketBaccaratNewSet = (data: any) => {
			if (this.state.logSocketEvents)
				console.debug("socketBaccaratNewSet", data);

			// Todo: add socket event suppression

			// console.log(`baccaratNewSet${variant.toUpperCase()} data`, data);

			// Clears roadmap
			const pcode = data.pcode;
			const _games = lobby.state.games;

			if (!_games[pcode])
				return;

			_games[pcode].roadmap.big_road = [];
			_games[pcode].newSet = !data.status;

			delete _games[pcode].virtualCardScanResult;

			lobby.setState({ games: _games });
		};

		// console.log(`baccaratmachineNewset${variantUpper}`)

		// On Baccarat new shoe
		socket.on(`baccaratNewSet${variantUpper}`, socketBaccaratNewSet);

		// On baccaratmachineNewset new shoe
		socket.on(`baccaratmachineNewset${variantUpper}`, socketBaccaratNewSet);

		// IDN 4 Stand same as Baccarat
		socket.on(`idn4standNewSet${variantUpper}`, socketBaccaratNewSet);



		// On Dragon & Tiger new shoe
		socket.on(`dragonTigerNewSet${variantUpper}`, (data: any) => {
			// Clears roadmap
			const pcode = data.pcode;
			const _games = lobby.state.games;

			// Todo: add socket event suppression

			if (!_games[pcode])
				return;

			_games[pcode].roadmap.big_road = [];
			_games[pcode].newSet = !data.status;

			_games[pcode].virtualCardScanResult = defaultDragonTigerResult;

			lobby.setState({ games: _games });
		}
		);

		// On Shio Fights new shoe
		socket.on(`shioFightNewSet${variantUpper}`, (data: any) => {
			// console.log(`shioFightNewSet${variant.toUpperCase()} data`, data);

			// Todo: add socket event suppression

			// Clears roadmap
			const pcode = data.pcode;
			const { games } = lobby.state;

			if (!games[pcode]) return;

			games[pcode].roadmap.big_road = [];
			games[pcode].newSet = !data.status;

			games[pcode].virtualCardScanResult = defaultShioFightResult;

			lobby.setState({ games: games });
		});
	});

	socket.on(`niuniuScan`, (data: INiuNiuSocketData) => {
		// Todo: optimise this with diff

		const { games } = lobby.state;
		const pcode = data.pcode;

		if (!games[pcode]) return;

		// Diff pattern
		const combined = [data.banker, data.player1, data.player2, data.player3].join(" ");

		if (this.prevScanValue[pcode] === combined)
			return;

		this.prevScanValue[pcode] = combined;
		// End diff pattern

		if (this.state.logNNScanEvent)
			console.debug("niuniuScan set state call");

		if (data.submit) {
			const newHistoryItem: INiuNiuHistoryType = {
				...data,

				dealer: data.banker,
				valuedealer: data.valueBanker,
				valueplayer1: data.valuePlayer1,
				valueplayer2: data.valuePlayer2,
				valueplayer3: data.valuePlayer3,
				result: data.winners.join(",")
			};

			games[pcode].history.unshift(newHistoryItem);

			lobby.setState({ games: games });
		}

		window.setTimeout(() => {
			games[pcode].niuNiuResult = data;
			lobby.setState({ games: games });
		}, 6500);
	}
	);

	// Copied and modified from mobile
	socket.on("lottoScan", (data: ILottoSocketData) => {
		if (this.state.logLottoScanEvent)
			console.debug("lottoScan", data);

		const { games } = lobby.state;

		if (!games || !games[data.pcode]) return;

		const activeGame = games[data.pcode];

		// Begin diff pattern
		if (this.prevScanValue[data.pcode] === data.number)
			return;

		this.prevScanValue[data.pcode] = data.number;
		// End diff pattern


		window.setTimeout(() => {
			activeGame.lottoResult = data;
			lobby.setState({ games: games });
		}, 5000);
	});

	interface IShioFightScanData {
		pcode: string;
		di: string;
		tian: string;
		value: string; // number string
		win: string;
		submit: boolean;
		periode: number;
		gameSet: number;
	}

	socket.on("shioFightScan", (data: IShioFightScanData) => {
		// Todo: optimise this with diff

		// console.log("sFS", JSON.stringify(data));

		const { pcode } = data;
		const { games } = lobby.state;
		const activeGame = games[pcode];

		if (!games || !activeGame)
			return;

		window.setTimeout(() => {
			activeGame.virtualCardScanResult = data;

			if (!activeGame.roadmap)
				activeGame.roadmap = { big_road: [] };

			const roadmapBigRoad = activeGame.roadmap.big_road;

			if (data.submit && !activeGame.pushedBigRoad) {
				const bigRoad = {
					di: data.di,
					tian: data.tian,
					win: data.win,
					gamekey: 1,
					periode: data.periode
				};

				roadmapBigRoad.push(bigRoad);

				activeGame.pushedBigRoad = true;
				activeGame.historyBlink = true;
				window.setTimeout(() => {
					activeGame.historyBlink = false;

					lobby.setState({ games: games });
				}, 6500);
			}

			lobby.setState({ games: games });
		}, 500);
	});


	// Misc Socket listeners
	socket.on("connect_failed", () => {
		console.log("Failed to connect to server");
	});


	socket.on("disconnect", () => {
		// This will prevent console from writing disconnection message
	});

	// refreshes active user count
	// socket.on("user_recount", (data: any) => {
	// 	// console.log("socket ur dat", data);
	// 	lobby.setState({ userCount: data });
	// });

	socket.on("reconnect_attempt", () => {
		socket.io.opts.transports = ["websocket"]; // "polling",
	});
}

function closeTimer(this: Desktop, pcode: string) {
	const { games, timers } = this.state;
	const game = games[pcode];

	if (!games || !game || !timers ||
		game.hasBetCloseChecked)
		return;

	const basePcode = getBasePcode(pcode);
	const machineGame = isMachineGame(pcode);

	if (v2games.indexOf(getBasePcode(pcode)) >= 0) {
		window.setTimeout(() => {
			const table = document.getElementById("table_" + pcode);
			if (table)
				table.className += " relaxed";
		}, 100);

		window.setTimeout((lobby: any) => {
			lobby.setState({ relaxed: true });
			lobby.forceUpdate();
		}, 1200, this);
	}

	timers[pcode].time = 0;

	// Resets Total Win
	game.totalWin = 0;


	// Skips applying lastBet (only for machine games)
	const skipLastBet = isMachineGame(basePcode);

	if (!skipLastBet) {
		// forces to click clear, then fillCurrentBet, then insertBet
		const filteredLastBet = getLastBetArray(this.state.userdata, pcode);
 
		if (filteredLastBet.length > 0)
			purgeApplyLastBet(game, filteredLastBet);
			// console.log("test");
		else applyClearBet(game, undefined, { skipConfirm: true });

		recountTotal(game);
	}

	// Deletes tickets if the game is after rebet
	if (machineGame && game.mustSubmitTickets) {
		game.tickets = [];

		recountTotal(game);
	}

	game.hasBetCloseChecked = true;

	window.setTimeout(() => {
		this.setState({
			games: games,
			timers: timers
		}); // closeTimer
	}, 100);
}

export {
	applyGameResult,
	closeTimer,
	initSocketIO,
	loadNewValue
};
